<template>
  <div>
    <vs-card class="p-5">
      <div style="position: relative; margin-top: 15px">
        <div style="position: absolute; top: 2px;">
          <vs-switch v-model="isStoreOpen" @change="modifyConfig()"/>
        </div>
        <h3 style="margin-left: 50px;">Local abierto hoy</h3>
      </div>
      <div style="position: relative; margin-top: 15px">
        <div style="position: absolute; top: 2px;">
          <vs-switch v-model="isStockWorking" @change="modifyConfig()"/>
        </div>
        <h3 style="margin-left: 50px;">Stock funcionando</h3>
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isStoreOpen: true,
      isStockWorking: true,
      antiRepeatCounter: 0,
    };
  },
  computed: {
  }, // COMPUTED
  created() {
    this.getConfigDB();
  }, // CREATED
  methods: {
    getConfigDB() {
      const vm = this;
      this.conectToDB({
        file: 'Config', action: 'getConfig', params:  { branchID: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          let Config = res.data.data[0];
          vm.isStoreOpen = Config.isStoreOpen;
          vm.isStockWorking = Config.isStockWorking
          vm.$store.dispatch('config/setConfigDB', res.data.data[0]);
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
    modifyConfig() {
      // fix double call
      if (this.antiRepeatCounter++ % 2 != 0) return;
      if (!confirm('Estás seguro que querés cambiar? Esto provocará cambios importantes!')) return;
      // modifyDB
      let Params = {
        branchID: 1,
        isStoreOpen: this.isStoreOpen,
        isStockWorking: this.isStockWorking
      }
      const vm = this;
      this.conectToDB({
        file: 'Config', action: 'modifyConfig', params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.myNotify('success', 'Éxito', 'Se modificó correctamente');
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
  }, // METHODS
} // export default
</script>

<style lang="css" scoped>
</style>
